import { c as _c } from "react/compiler-runtime";
import EntityCard from '@/components/modules/EntityCard';
import { LOCALE } from '@/constants/config';
import { EXPERIENCE_TYPES } from '@/constants/experience';
import useIsDev from '@/contexts/appContext/hooks/useIsDev';
import useActiveBreakpoints from '@/contexts/tailwindContext/hooks/useActiveBreakpoints';
import useQuery from '@/hooks/useQuery';
import { BookableListQuery } from '@/queries/bookables.gql';
import { FPagePreciseNameEnum } from '@/types/pages';
import sendGTMPageView from '@/utils/gtm/sendGTMPageView';
import { Loader } from '@winelidays/wld-tsx-2/elements';
import { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const HomePage = () => {
    const $ = _c(16);
    const { md } = useActiveBreakpoints();
    const isDev = useIsDev();
    const location = useLocation();
    let t0;
    let t1;
    if ($[0] !== location.pathname) {
        t0 = () => {
            sendGTMPageView({ custom_page_path: location.pathname, page_name: FPagePreciseNameEnum.experienceList, experience_id: null });
        };
        t1 = [location.pathname];
        $[0] = location.pathname;
        $[1] = t0;
        $[2] = t1;
    }
    else {
        t0 = $[1];
        t1 = $[2];
    }
    useEffect(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = { fetchPolicy: "cache-and-network", variables: { cheap: false, locale: LOCALE } };
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const { data, error } = useQuery(BookableListQuery, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <Loader />;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    let t4;
    if ($[5] !== error || $[6] !== isDev) {
        t4 = isDev ? <div className="max-w-full">{JSON.stringify(error)}</div> : null;
        $[5] = error;
        $[6] = isDev;
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    let t5;
    if ($[8] !== data || $[9] !== md) {
        t5 = data?.bookableList.length ?
            data.bookableList.filter(_temp).map((experience) => <li key={experience.id} className="experience-list-item flex flex-col border-b border-gray-100 py-5 md:py-6 first:!pt-0 last:!pb-0 last:border-b-0">

      <EntityCard entity={experience} vertical={!md} hideLocation={true}/>
    </li>) : null;
        $[8] = data;
        $[9] = md;
        $[10] = t5;
    }
    else {
        t5 = $[10];
    }
    let t6;
    if ($[11] !== t5) {
        t6 = <ul>{t5}
    </ul>;
        $[11] = t5;
        $[12] = t6;
    }
    else {
        t6 = $[12];
    }
    let t7;
    if ($[13] !== t4 || $[14] !== t6) {
        t7 = <div className="relative w-full flex flex-col min-h-100"><Suspense fallback={t3}>{t4}{t6}
      </Suspense>
    </div>;
        $[13] = t4;
        $[14] = t6;
        $[15] = t7;
    }
    else {
        t7 = $[15];
    }
    return t7;
};
export default HomePage;
function _temp(t0) { const { type } = t0; return EXPERIENCE_TYPES.includes(type); }
